exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* -- Page footer -- */\n/* -- Mixins -- */\n.page-footer {\n  font-family: \"Gotham Pro Medium\";\n  color: white;\n  background-color: #2B3671; }\n  .page-footer-inner {\n    padding: 25px 0;\n    border-top: 2px solid rgba(255, 255, 255, 0.3); }\n\n.footer-logo img {\n  display: block;\n  float: left; }\n\n.footer-logo .text {\n  display: block;\n  margin-left: 60px; }\n\n.footer-logo-uni {\n  float: right; }\n  .footer-logo-uni .top {\n    margin-bottom: 10px; }\n\n.footer-location .text, .footer-phone .text {\n  display: block;\n  margin-left: 30px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/ras.universarium.org/www/src/app/footer/footer.component.scss
// module id = ../../../../../src/app/footer/footer.component.scss
// module chunks = 1